import { TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, ElementRef, Input, Output, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'bb-cron',
	templateUrl: './bb-cron.component.html',
	styleUrls: ['./bb-cron.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbCronComponent),
		multi: true
	}]

})

export class BbCronComponent implements ControlValueAccessor, OnInit {

	@Input() disabled = false;
	@Output() onChanged = new EventEmitter<any>();

	el: HTMLElement;
	advancedMode = true;
	modelValue = '0 0 * * *';
	weekDays: number[] = [];
	hours: number[] = [];
	minutes: string[] = [];
	minuteString = '0';
	showAllHours = false;
	helpLink = '';

	weekdayOptions = [
		{ label: this.translate.instant('SUNDAY'), value: 0 },
		{ label: this.translate.instant('MONDAY'), value: 1 },
		{ label: this.translate.instant('TUESDAY'), value: 2 },
		{ label: this.translate.instant('WEDNESDAY'), value: 3 },
		{ label: this.translate.instant('THURSDAY'), value: 4 },
		{ label: this.translate.instant('FRIDAY'), value: 5 },
		{ label: this.translate.instant('SATURDAY'), value: 6 },
	];
	hourOptions = [];

	constructor(
		private _eref: ElementRef,
		private translate: TranslateService
	) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() {
		this.setHourOptions();
		this.update();
	}

	toggleHours() {
		this.showAllHours = !this.showAllHours;
		this.setHourOptions();
	}

	update() {
		if (!this.modelValue) {
			return;
		}
		const parts = this.modelValue.split(' ');
		if (parts.length < 5) {
			return;
		}

		this.weekDays = this.stringToNumberArray(parts[4], 7);
		this.hours = this.stringToNumberArray(parts[1], 24);
		this.minutes = this.stringToNumberArray(parts[0], 60);
		this.minuteString = this.minutes && this.minutes.length ? this.minutes[0] : '*';
		this.helpLink = 'https://crontab.guru/#' + (this.modelValue ? this.modelValue.replace(/ /g, '_') : '0_0_*_*_*');
	}

	setHourOptions() {
		const allHourOptions = [];
		for (let i = 0; i < 24; i++) {
			allHourOptions.push({
				label: i,
				value: i
			});
		}
		if (this.showAllHours) {
			this.hourOptions = allHourOptions;
		} else {
			this.hourOptions = allHourOptions.filter(o => {
				const h = o.value;
				return h % 2 === 0 && h > 4 && h < 20;
			});
		}
	}

	onToggleModeClick() {
		this.advancedMode = !this.advancedMode;
	}

	updateCronString() {
		const hoursString = this.hours.length ? this.hours.join(',') : '*';
		const weekDaysString = this.weekDays.length ? this.weekDays.join(',') : '*';
		this.minutes = [this.minuteString];
		const minuteString = this.minutes.length ? this.minutes.join(',') : '*';
		this.modelValue = `${minuteString} ${hoursString} * * ${weekDaysString}`;
		this.update();
		this.propagateChange(this.modelValue);

	}

	onCronStringChange() {
		this.update();
	}

	stringToNumberArray(str: string, m: number = 1) {
		if (str === '*') {
			return [];
		}
		const ret = [];
		str.split(',').forEach(d => {
			if (d.includes('-')) {
				const dParts = d.split('-');
				let i = Number(dParts[0]);
				const max = Number(dParts[1]);
				while (i <= max) {
					ret.push(i % m);
					i++;
				}
			} else {
				ret.push(Number(d) % m);
			}
		});
		return ret;
	}

	propagateChange = (_: any) => { };

	writeValue(value: any) {
		this.modelValue = value;
		this.update();
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
